import * as React from 'react';
export const volksbankatSvg = React.forwardRef(function volksbankatSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#00508D',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M4.36 8.73h9.31l2.52 9.04 2.33-9.04h9.1s.12.11-.43 1.45h-5.85l-.26 1.46h5.63s-.1.2-1.26 1.45h-5.12l-.21 1.46h4.37s-.62.33-2.35 1.45h-2.68l-2.54 8.73h-1.7L12.63 16H9.88c.02 0-1.54-.52-2.47-1.45h4.6l-.25-1.46H6.69s-.87-.44-1.28-1.45h5.7l-.29-1.46h-5.9s-.56-.58-.56-1.45z',
      }),
    ),
  );
});
volksbankatSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var volksbankat = {
  category: 'brand',
  colorable: false,
  name: 'volksbankat',
  svg: volksbankatSvg,
};
